// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3cdz0","selects":"Documents_selects__3UCCm"};